<template>
  <v-text-field
    v-model="textValue"
    dense
    outlined
    :disabled="disabled"
  >
    <template #label>
      <span class="info--text">
        {{ label }}
        <span
          v-if="required"
          class="red--text"
        >
          *
        </span>
      </span>
    </template>
  </v-text-field>
</template>

<script>
export default {
  name: 'BaseFormTextField',
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    textValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
